import {CityProps} from 'modules/cities/types';
import citiesKeys from 'modules/cities/util/cities-keys';
import React from 'react';
import StatusButton from 'shared/components/status-button';
import List from 'shared/layout/list';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';

const Cities: React.FC = () => {
  const projection = useProjection<CityProps>('cities', [
    'id',
    'name',
    'active',
    'state',
  ]);

  return (
    <List<CityProps>
      {...{
        titleBar: {
          title: 'Cidades',
          actionButton: {title: 'NOVA CIDADE', to: 'create'},
        },
        table: {
          url: '/cities',
          projection: {
            ...projection,
            options: [
              'name',
              'state',
              {
                value: 'cashback',
                column: (row) => (row.cashback ? `${row.cashback}%` : ''),
                filter: {
                  type: 'text',
                  valueAsNumber: true,
                },
              },
              {
                value: 'withCashback',
                column: (row) => (
                  <StatusButton
                    text={row.withCashback ? 'Sim' : 'Não'}
                    variant={row.withCashback ? 'success' : 'error'}
                  />
                ),
                filter: {
                  type: 'select',
                  values: [
                    {label: 'Sim', value: true},
                    {label: 'Não', value: false},
                  ],
                },
              },
              {
                value: 'cashbackExpiration',
                column: (row) =>
                  row.cashbackExpiration
                    ? `${row.cashbackExpiration} dias`
                    : '',
                filter: {
                  type: 'text',
                  valueAsNumber: true,
                },
              },
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      isChecked={row.active}
                      url={`/cities/${row.id}`}
                      queryKey={citiesKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
            ],
          },
          translatedPropsKey: 'CityProps',
        },
        queryKey: citiesKeys.list(),
      }}
    />
  );
};

export default Cities;
